var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('label',{attrs:{"for":_vm.colordef.color}},[_vm._v(_vm._s(_vm.colordef.color))]),_c('input',{attrs:{"type":"color","id":_vm.colordef.color,"name":""},domProps:{"value":_vm.colordef.hex},on:{"change":_vm.emit}})])}
var staticRenderFns = []

export { render, staticRenderFns }